import React, { useState } from "react";
import { usePermissions } from "./App";
import useSWR from "swr";
import TableTotalNCost from "./TableTotalNCost";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import SearchFilter from "./SearchFilter";
import LoaderAnimation from "./LoaderAnimation";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });

const ClientRegister = () => {
  // eslint-disable-next-line no-unused-vars
  const [modalMessages, setModalMessages] = useState("");
  // eslint-disable-next-line no-unused-vars
  const perm = usePermissions();

  const [searchTerm, setSearchTerm] = useState("");
  useState("");

  const username = ls.get("username");
  const userpw = ls.get("userpw");
  const usercsrf_token = ls.get("usercsrf_token");

  const fetcher = (url) =>
    fetch(url, {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
        "X-CSRF-Token": usercsrf_token,
      },
    })
      .then((res) => res.json())
      .then((data) => (Array.isArray(data) ? data : [data]));

  const {
    data: voucherData,
    error: voucherDataError,
    isLoading: voucherDataLoading,
  } = useSWR(`${process.env.REACT_APP_CLIENT_REGISTER_API}`, fetcher);

  const filteredData = Array.isArray(voucherData)
    ? voucherData.filter((request) => {
        const matchesSearchTerm =
          request.field_voucher_code
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_first_name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_last_name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_date_of_birth
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          request.field_gender
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_contact_number
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_client_email_address
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_location
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase());

        return matchesSearchTerm;
      })
    : [];

  if (voucherDataError) {
    return (
      <LoaderAnimation
        loadingTxt={`Check your network / internet connection and try again!, ${voucherDataError}`}
      />
    );
  }

  if (voucherDataLoading) {
    return <LoaderAnimation loadingTxt="Loading..." />;
  }

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="patient-register">
          <TopActionMenus AddTitle="Voucher register" />
          <SearchFilter
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            // statusFilter={statusFilter}
            // setStatusFilter={setStatusFilter}
            // voucherGenerationStartDate={voucherGenerationStartDate}
            // setVoucherGenerationStartDate={setVoucherGenerationStartDate}
            // voucherGenerationEndDate={voucherGenerationEndDate}
            // setVoucherGenerationEndDate={setVoucherGenerationEndDate}
            // categoryFilter={categoryFilter}
            // setCategoryFilter={setCategoryFilter}
            // categoryOptions={categoryOptions}
          />

          {filteredData.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <td>First Name</td>
                  <td>Last Name</td>
                  <td>Gender</td>
                  <td>Date of Birth</td>
                  <td>Contact Number</td>
                  <td>Email Address</td>
                  <td>Location</td>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((row) => (
                  <tr key={row.voucher_nid}>
                    <td>{row.field_first_name}</td>
                    <td>{row.field_last_name}</td>
                    <td>{row.field_gender}</td>
                    <td>{row.field_date_of_birth}</td>
                    <td>{row.field_contact_number}</td>
                    <td>{row.field_client_email_address}</td>
                    <td>{row.field_location}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <LoaderAnimation loadingTxt="No matching records found" />
          )}

          {filteredData.length > 0 && (
            <TableTotalNCost
              noOfReportLable="Number of client :"
              noOfReportLength={filteredData.length}
              totalRequestFeeCostValue={filteredData.reduce((total, item) => {
                return total + (Number(item?.field_payment_amount) || 0);
              }, 0)}
            />
          )}
        </div>
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default ClientRegister;
